import { render } from "./aereotermo.vue?vue&type=template&id=a1231624&scoped=true"
import script from "./aereotermo.vue?vue&type=script&lang=js"
export * from "./aereotermo.vue?vue&type=script&lang=js"

import "./aereotermo.vue?vue&type=style&index=0&id=a1231624&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a1231624"]])

export default __exports__